module.exports = __webpack_public_path__ + "static/media/mobile_music_2x.c7fc0f3f.png";